module.exports = __webpack_public_path__ + "static/media/not_found.bf8de4f3.png";